<div id="notfound" class="d-flex align-items-center justify-content-center">
  <div class="d-flex flex-column align-items-center gap-4">
    <div class="notfound-404">
      <h1 class="oops">Oops!</h1>
    </div>
    <h2>404 - Page not found</h2>
    <p class="w-50">
      The page you are looking for might have been removed had its name changed
      or is temporarily unavailable.
    </p>
    <button class="btnGlobal--primary" routerLink="/">Go To Homepage</button>
  </div>
</div>
